import { render, staticRenderFns } from "./signUpToast_v1.vue?vue&type=template&id=478fc49b&scoped=true"
import script from "./signUpToast_v1.vue?vue&type=script&lang=js"
export * from "./signUpToast_v1.vue?vue&type=script&lang=js"
import style0 from "./signUpToast_v1.vue?vue&type=style&index=0&id=478fc49b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478fc49b",
  null
  
)

export default component.exports